export default __webpack_public_path__ + "static/media/logo_googleg_48dp.b3d49bbe.svg";